export default {
	state: {
		active: false,
		show_overlay: true,
		current_task: 0,
	},
	mutations: {

	}
}
